import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

/**
 * MUI port of the RN AlertModal API:
 *   <AlertModal visible title message actions onRequestClose />
 * Each action: { text, onPress, variant: 'primary' | 'danger' | undefined }
 */
export default function AlertModal({ visible, title, message, actions = [], onRequestClose }) {
  return (
    <Dialog open={!!visible} onClose={onRequestClose} maxWidth="xs" fullWidth>
      {title && <DialogTitle sx={{ fontWeight: 700 }}>{title}</DialogTitle>}
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {actions.length === 0 ? (
          <Button onClick={onRequestClose} variant="contained">
            OK
          </Button>
        ) : (
          actions.map((a, idx) => {
            const color =
              a.variant === 'danger' ? 'error' : a.variant === 'primary' ? 'primary' : 'inherit';
            const variant = a.variant ? 'contained' : 'text';
            return (
              <Button key={idx} onClick={a.onPress} color={color} variant={variant}>
                {a.text}
              </Button>
            );
          })
        )}
      </DialogActions>
    </Dialog>
  );
}
